import React from "react";
import CardBase from "./CardBase";
import HorizontalTabs from "../tabs/HorizontalTabs";

class TabsCard extends CardBase {
    renderBody = () => {
        const {items} = this.props;
        return <HorizontalTabs items={items}/>
    };
}

export default TabsCard;
